import { Controller } from '@hotwired/stimulus'
import TomSelect from "tom-select";

export default class extends Controller {
  static targets = ["SupplierSelect", "EmailInput", "SeedSupplierId", "SeedSupplierType", "BodyTextArea"]

  connect() {
    this.element[this.identifier] = this
    this.initSeedSupplierTomSelect()
  }

  initSeedSupplierTomSelect() {
    this.SupplierTomSelectTarget = new TomSelect(this.SupplierSelectTarget, { allowEmptyOption: true, placeholder: "Type or select" })

    this.SupplierTomSelectTarget.on("change", (value) => {
      this.SupplierSelectTarget.value = value
    })

    this.SupplierTomSelectTarget.trigger("change")
  }

  changeSupplier() {
    const supplierVal = this.SupplierSelectTarget.value;
    console.log('supplierVal', supplierVal)
    const supplierDataElement = document.getElementById(supplierVal);

    let supplierData = null;
    if (supplierDataElement) {
      supplierData = JSON.parse(supplierDataElement.innerHTML);
    }

    if (supplierData) {
      console.log('supplierData', supplierData)
      this.EmailInputTarget.value = supplierData.po_email

      var bodyText = this.BodyTextAreaTarget.value
      if (bodyText.includes("%supplier_name%")) {
        bodyText = bodyText.replace("%supplier_name%", supplierData.name)
      } else {
        // replace first line that will be in format of "supplier_name,\n\n"
        bodyText = bodyText.replace(/.*,\n\n/, supplierData.name + ",\n\n")
      }
      this.BodyTextAreaTarget.value = bodyText

      if (supplierData.type == "Listing") {
        this.SeedSupplierIdTarget.value = supplierData.user_id;
        this.SeedSupplierTypeTarget.value = "User";
      } else {
        this.SeedSupplierIdTarget.value = supplierData.id;
        this.SeedSupplierTypeTarget.value = "SeedSupplier";
      }
    } else {
      this.SeedSupplierIdTarget.value = ""
    }
  }

}